import instagram from '../Components/Assets/instagram_icon.png'
import youtube from '../Components/Assets/youtube_icon.png'
import facebook from '../Components/Assets/facebook_icon.png'
import './CSS/Confirmation.css';
import { useEffect, useState } from 'react';
import { updateInventory } from '../utils/inventoryService';

const Confirmation = () => {
  const [digitalItems, setDigitalItems] = useState([]);

  useEffect(() => {
    const updateDatabase = async () => {
      try {
        // Retrieve purchased items from session storage
        const purchasedItemsStr = sessionStorage.getItem('purchasedItems');
        console.log('Raw sessionStorage purchasedItems:', purchasedItemsStr);
        
        if (!purchasedItemsStr) {
          console.log('No purchased items found in session storage.');
          return;
        }

        const purchasedItems = JSON.parse(purchasedItemsStr);
        console.log('Parsed purchased items:', purchasedItems);
        console.log('Items count:', purchasedItems.length);

        // Debug each item
        purchasedItems.forEach((item, idx) => {
          console.log(`Item ${idx}:`, {
            id: item.id,
            name: item.name,
            fileType: item.fileType,
            pdfUrl: item.pdfUrl,
            hasFileType: !!item.fileType,
            hasPdfUrl: !!item.pdfUrl
          });
        });

        // Filter for digital items - check both fileType and pdfUrl
        const digital = purchasedItems.filter(item => {
          const isDigital = item.fileType === 'digital' || item.fileType === 'both';
          const hasPdf = item.pdfUrl && item.pdfUrl.trim() !== '';
          console.log(`Filtering ${item.name}: isDigital=${isDigital}, hasPdf=${hasPdf}`);
          return isDigital && hasPdf;
        });
        
        console.log('Filtered digital items with PDFs:', digital);
        setDigitalItems(digital);

        // Extract product IDs and quantities for inventory update
        const itemsForUpdate = purchasedItems.map(item => ({
          id: item.id,
          quantity: item.quantity
        }));

        // Send purchased items to the backend to update inventory
        const data = await updateInventory(itemsForUpdate, 'unknown');

        if (data.success) {
          console.log('Inventory updated successfully:', data);
          // Clear session storage after successful update
          sessionStorage.removeItem('purchasedItems');
        } else {
          console.error('Failed to update inventory:', data.error);
        }
      } catch (error) {
        console.error('Error in confirmation page:', error.message);
      }
    };

    updateDatabase();
  }, []);

  const handleDownload = (pdfUrl, itemName) => {
    if (pdfUrl) {
      // Create a temporary link and trigger download
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${itemName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className='confcontainer'>
      <div className="confirmation-page">
        <h1>Thank You for Your Purchase! Your receipt has been sent to your email for your records.</h1>
        
        {/* Digital Items Downloads Section */}
        {digitalItems && digitalItems.length > 0 ? (
          <div className="digital-downloads">
            <h2>Your Digital Downloads</h2>
            <p>Click the button below to download your digital items:</p>
            <div className="downloads-list">
              {digitalItems.map((item, index) => (
                <div key={index} className="download-item">
                  <p className="download-name">{item.name}</p>
                  {item.pdfUrl ? (
                    <button 
                      className="download-button"
                      onClick={() => handleDownload(item.pdfUrl, item.name)}
                    >
                      Download PDF
                    </button>
                  ) : (
                    <p className="no-file">PDF file not available</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="no-digital-items">
            <p>No digital items in this order.</p>
          </div>
        )}
        
        <h2>Stay connected with us by following MarieMadeIt on social media for updates, new products, and Pattern tester calls.</h2>  
        <a className='social' href='https://www.instagram.com/mariemadeit__/?hl=en' _blank='target'><img src={instagram} alt='instagram-logo'/>Instagram</a>
        <a className='social' href='https://www.youtube.com/@MarieMadeIt96'><img src={youtube} alt='youtube-logo'/>Youtube</a>
        <a className='social' href='https://www.facebook.com/profile.php?id=100077528543304'><img src={facebook} alt='facebook-logo'/>Facebook</a>
        <p>Thank you once again for choosing MarieMadeIt!</p>
        <a className='returnbtn' href="/">Return Home</a>
      </div>
    </div>
  );
};

export default Confirmation;
